import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, Tag } from './index';

export interface TagByIdGetParams {
  id: string;
}

export const tagById = (payload: TagByIdGetParams): Action<TagByIdGetParams> => ({
  type: actions.tagByIdTrigger.toString(),
  payload,
});

export const tagByIdClear = (): Action => ({
  type: actions.tagByIdClear.toString(),
});

export function* tagByIdRequestSaga({ payload }: Action<TagByIdGetParams>) {
  yield put({
    type: actions.tagByIdStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.tagByIdError.toString(),
      payload: {
        message: 'TagById: Parameters not passed.',
      },
    });

    return;
  }

  const { id } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/articles/tags/${id}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<Tag, Tag>(
    response,
    actions.tagByIdSuccess.toString(),
    actions.tagByIdError.toString(),
    false,
    (tagByIdData) => tagByIdData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.tagByIdTrigger.toString(),
    defaultProcessingSaga(
      tagByIdRequestSaga,
      {
        error: actions.tagByIdError.toString(),
        locationCancel: actions.tagByIdClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.tagByIdSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.tagByIdError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.tagByIdErrorReset.toString(),
    });
  });
}
